import type { CardImageWidth } from '~/types/AppData/PageBuilder/CardBlockInterface';
import type { GalleryColumnWidth } from '~/types/AppData/PageBuilder/GalleryColumnBlockInterface';
import type { ImageWidths } from '~/types/AppData/PartialImageTypes';

export const getCardImageWidths = (
  imageWidth: CardImageWidth,
  aspectRatio: string,
  columnWidth: GalleryColumnWidth = 'twoColHalf',
  columns?: number,
  isHero?: boolean
): ImageWidths => {
  if (imageWidth === 'small') {
    return {
      small: aspectRatio === '5/4' ? 98 : 102,
      medium: 159,
      large: aspectRatio === '5/4' ? 100 : 120,
    };
  }

  if (imageWidth === 'medium') {
    return {
      small: 160,
      medium: 160,
      large: 186,
    };
  }

  if (imageWidth === 'half') {
    // if columnWidth === 'full': Spotlight card - switches to a vertical layout on small screens.
    return {
      small: columnWidth === 'full' ? 335 : 160,
      medium: columnWidth === 'full' ? 680 : 332,
      large: columnWidth === 'full' ? 530 : 280,
    };
  }

  if (columns === 1 && imageWidth === 'full' && !isHero) {
    return {
      small: 335,
      medium: 680,
      large: 1000,
    };
  }

  if (isHero) {
    return {
      small: 767,
      medium: 1000,
      large: 1800,
    };
  }

  if (imageWidth === '3/12') {
    return {
      small: 335,
      medium: 159,
      large: 254,
    };
  }

  // Full width card
  return {
    small: 335,
    medium: 680,
    large: columnWidth === 'threeColSmall' ? 320 : 600,
  };
};
